// @ts-nocheck
import React, { useState } from 'react';
import CommunicationContainer from '../communicationcontainer';
import AppHeader from 'components/appheader';
import { useDump } from 'lib/useDump';

const AppContainer = () => {
  const [communicationsToRead, setCommunicationsToRead] = useState<
    ICommunication[] | null
  >(null);
  const { dump } = useDump();

  React.useEffect(() => {
    if (dump) {
      setCommunicationsToRead(dump.communicationsToRead);
    }
  }, [dump]);

  if (communicationsToRead && communicationsToRead.length > 0) {
    return (
      <CommunicationContainer
        title={communicationsToRead[0].title}
        content={communicationsToRead[0].content}
        choice={communicationsToRead[0].choice}
        communicationId={communicationsToRead[0].communicationId}
      />
    );
  } else if (communicationsToRead) {
    return <AppHeader />;
  } else {
    return <div></div>;
  }
};

export default AppContainer;
